module.exports = __webpack_public_path__ + "img/up-down-arrows.30ea76e.svg";